module.exports = __webpack_public_path__ + "img/31.8a9e5e4a.png";